module.exports = __webpack_public_path__ + "static/img/01.9b41caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/01.jpg
// module id = 423
// module chunks = 1